<template>
  <div class="of-auto">
    <ul class="thread list-unstyled">
      <li class="message" v-for="m in thread" :key="m.key">
        <span class="display-name badge badge-pill badge-primary">
          {{ m.nickname }}
        </span>
        :
        <span class="message badge badge-pill badge-light" :class="{ illigal : hasBadWord(m.message) }">
          {{ m.message }}
        </span>
        <b-btn variant="link" @click="showReasonModal(m)">ban</b-btn>
      </li>
    </ul>

    <b-modal
      @ok="handleOk"
      @cancel="handleCancel"
      id="banWatcher"
      ref="banWatcher"
      title="사용자 차단"
      centered>
      <b-form-group label="사유">
        <b-input-group>
          <b-form-input
            placeholder="차단 사유를 적어 주세요"
            v-model="reason"
            type="text">
          </b-form-input>
        </b-input-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  mapGetters,
  mapState
} from 'vuex'
import l from '@/vendor/logger'

export default {
  name: 'ChatThread',

  created () {
    // this.$store.dispatch('setMode', 'PROD')
    // this.$store.dispatch('setMode', this.$route.params.mode.toUpperCase())
    this.$store.dispatch('chatOption/bindFilteringWords')
    l.d('ChatThreadLG/created/filteringWords', this.filteringWords)
  },

  data () {
    return {
      reason: '',
      message: null
    }
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  updated () {
    this.$el.scrollTop = this.$el.lastElementChild.offsetTop
  },

  computed: {
    ...mapState('chat', [
      'thread'
    ]),
    ...mapGetters('chatOption', [
      'filteringWords'
    ])
  },
  methods: {
    unbind () {
      this.$store.dispatch('chatOption/unbindFilteringWords')
    },
    showReasonModal (m) {
      this.message = m
      this.$refs['banWatcher'].show()
    },
    ban (m) {
      this.reason === '' && (this.reason = 'no reason')
      this.$store.dispatch('chatOption/addWatcher', { ...m, reason: this.reason })
      this.reason = ''
    },
    hasBadWord (msg) {
      if (!msg) return
      return msg.split(' ')
        .filter(m => this.filteringWords.includes(m))
        .reduce((acc, cur) => acc || !!cur, false)
    },
    messageColor (isBan) {
      return isBan ? 'red' : 'black'
    },
    handleCancel (evt) {
    },
    handleOk (evt) {
      !!this.message && this.ban(this.message)
    }
  }
}
</script>

<style scoped>
.thread {
  overflow: scroll;
}

.illigal {
  background-color: red;
}

.of-auto {
  overflow: auto;
}
</style>
